<template>
  <div>
    <template v-if="loading">
      <!-- TODO: loading spinner -->
    </template>
    <div v-else-if="compliances.length" v-cloak class="m-b-20">
      <div v-for="compliance in compliances" :key="compliance.name">
        <Ir35HireUpdateNotice
          v-if="compliance.name === 'IR35'"
          :has-bills="compliance.data.hasBills"
        />
        <UsWorkerClassificationHireUpdateNotice
          v-if="compliance.name === 'US_WORKER_CLASSIFICATION'"
          :has-bills="compliance.data.hasBills"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import gql from 'graphql-tag'
import { computed, defineProps } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { ACTIVE_COMPLIANCES_ON_HIRE_FRAGMENT } from '@/components/compliances/queries/Compliances'
import AccountType from '@/utils/AccountType'
import { ParseJSONPropertyInObject } from '@/utils/ParseJSONPropertyInObject'
import Ir35HireUpdateNotice from '@/components/compliances/alerts/Ir35HireUpdateNotice.vue'
import UsWorkerClassificationHireUpdateNotice from '@/components/compliances/alerts/UsWorkerClassificationHireUpdateNotice.vue'

const props = defineProps({
  hireId: {
    type: Number,
    required: true,
  },
})

const complianceNames = ['IR35', 'US_WORKER_CLASSIFICATION']

const { result, loading } = useQuery(
  gql`
    query getAccountAndHire($hireId: Int!, $complianceNames: [ComplianceName!]!) {
      hire(localId: $hireId) {
        ...ActiveCompliancesOnHire
      }
      me {
        activeAccount {
          __typename
        }
      }
    }
    ${ACTIVE_COMPLIANCES_ON_HIRE_FRAGMENT}
  `,
  {
    hireId: props.hireId,
    complianceNames,
  },
)

const activeAccount = computed(() => result?.value?.me?.activeAccount)
const compliances = computed(() => {
  if (!activeAccount.value || !AccountType.isCompany(activeAccount.value.__typename)) {
    return []
  }
  return (
    result?.value?.hire?.compliances
      ?.filter((compliance) => compliance.isApplicable)
      ?.map((compliance) => ParseJSONPropertyInObject('data', compliance)) || []
  )
})
</script>
